// import { products } from "../data/products.json";

const initState = {
  products: [],
  product: {},
  isFetching: false,
  filteredProducts: [],
  errorMessage:undefined
};
const productReducer = (state = initState, action) => {
  switch (action.type) {
    case "FETCH_PRODUCTS_START":
      return {
        ...state,
        isFetching:true
      };
    case "FETCH_PRODUCTS_SUCCESS":
      return {
        ...state,
        products: action.payload,
        isFetching: false
      };
    case "FETCH_PRODUCTS_FAILURE":
      return {
        ...state,
        isFetching: false,
        errorMessage: action.payload
      };
    case "PRODUCT":
      return {
        ...state,
        product: state.products.find(
          (product) => parseInt(product.id) === parseInt(action.id)
        ),
      };
    case "SEARCH":
      // eslint-disable-next-line
      const filterProducts = state.products.filter((product) => {
        if (
          product.description.toLowerCase().includes(action.payload) ||
          product.title.toLowerCase().includes(action.payload)
        ) {
          return product;
        }
      });
      console.log(filterProducts);
      return {
        ...state,
        filteredProducts: filterProducts,
      };
    default:
      return state;
  }
};
export default productReducer;
